import {Component, ViewChild} from '@angular/core';
import {OperatoriesService} from '../../operatories/operatories.service';
import {OfficeLocationsService} from '../../office-locations/office-locations.service';
import {DialogService} from '../../../../services/dialog.service';
import {Globals} from '../../../../globals';
import {MatDialog} from '@angular/material/dialog';
import {NonWorkingDaysService} from '../../../../services/configuration/non-working-days.service';
import {ConfigurationService} from '../../configuration.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {OrganizationDataModel} from '../../../../models/organization/organization-data.model';
import {TdoClientConfigurationModel} from '../../../../models/clients/tdo-client-configuration.model';
import {TdoTableV2Component} from '../../../../tdo-controls/common/tdo-table-v2/tdo-table-v2.component';
import {ReferralsService} from '../referrals.service';
import {
    emailInformationModel,
    OrganizationReferralEntityModel,
    ReferralEntityModel,
    ReferralEntityProviderDoctorsModel
} from '../models/referral-Entity.model';
import {
    OrganizationConfigurationDialogComponent
} from '../../organization-configuration/dialogs/organization-configuration-dialog/organization-configuration-dialog.component';
import {Constants} from '../../../../constants';
import {TdoTableSelectionEvent} from '../../../../tdo-controls/common/tdo-table-v2/models/tdo-table-selection.event';
import {OrganizationsService} from '../../organization-configuration/organizations-service';
import {StaticDataService} from '../../../../services/static-data.service';
import {DoctorDataModel} from '../../../../models/doctors/doctor-data.model';
import {environment} from '../../../../../environments/environment';
import {CommMethodEnum} from '../../../../models/enum/comm-method.enum';
import {EnumContactCategory} from '../../../../models/enum/enum-contact-category.enum';

export enum originSaving {
    organization = 1,
    token = 2,
    form = 3
}

@Component({
    selector: 'app-referral-client-setup',
    templateUrl: './referral-client-setup.component.html',
    styleUrls: ['./referral-client-setup.component.scss']
})

export class ReferralClientSetupComponent {
    @ViewChild('ReferralEntityTable') ReferralEntityTable: TdoTableV2Component;
    clientList: any[];
    listReferralEntities: ReferralEntityModel[];
    selectedClient: any;
    selectedReferralEntity: ReferralEntityModel;
    editedReferralsEntity: ReferralEntityModel[] = [];
    selectedProviders: DoctorDataModel[] = [];
    emailInformation: emailInformationModel;
    fromForm: originSaving;


    searchPredicate: (data: any, filter: string) => boolean;
    doctorPredicate: (data: DoctorDataModel) => string;
    currentURL: string;
    DoctorList: DoctorDataModel[] = [];
    subdomain: string = environment.subdomain;
    scheme: string = environment.scheme;


    constructor(private operatoriesService: OperatoriesService,
                private locService: OfficeLocationsService,
                private dialogService: DialogService,
                private globals: Globals,
                private dialog: MatDialog,
                private referralService: ReferralsService,
                private organizationsService: OrganizationsService,
                private nwds: NonWorkingDaysService,
                private configurationService: ConfigurationService,
                private staticDataService: StaticDataService,
                private snackbar: MatSnackBar) {
        this.searchPredicate = (dataSearch: ReferralEntityModel, filter: string) => dataSearch.ReferralClientName.toLowerCase().includes(filter);
        this.currentURL = [this.scheme, window.location.hostname, this.subdomain].join('');
        this.fromForm = originSaving.form;
    }

    ngAfterViewInit(): void {
        if (this.staticDataService.currentLocationDoctors === undefined) {
            this.staticDataService.getCurrentLocationDoctors();
        }
    }

    ngOnInit() {
        this.doctorPredicate = (data: DoctorDataModel) => {
            if (data.dataContact === undefined) {
                return '';
            }
            return 'Dr. ' + data.dataContact.FirstName + ' ' + data.dataContact.LastName;
        };
        this.loadServiceData();
    }

    loadServiceData() {
        this.locService.getClients().subscribe(data => {
            this.clientList = data;
            if (this.clientList.length > 0) {
                // Try to locate current users client
                const client = this.clientList.find(p => p.TDOCID.toString() === this.globals.TDOCID);
                if (client) {
                    this.selectedClient = client;
                } else {
                    this.selectedClient = this.clientList[0];
                }
            }
            this.loadTable();
        }, err => {
            console.log(err);
            // this.isBusy = false;
        });
    }

    onChangeClient(event) {
        const l = this.configurationService.checkIsDirty();
        if (l) {
            l.subscribe((res) => {
                if (res) {
                    this.changeClient(event.value);
                    return;
                } else {
                    this.ReferralEntityTable.selectionControl.select(this.selectedClient);
                }
            });
        } else {
            this.changeClient(event.value);
        }
    }

    onRowSelected(event: TdoTableSelectionEvent) {
        const l = this.configurationService.checkIsDirty();
        if (l) {
            l.subscribe((res) => {
                if (res) {
                    this.selectReferralEntity(event.model);
                    return;
                } else {
                    this.ReferralEntityTable.selectionControl.select(this.selectedClient);
                }
            });
        } else {
            this.selectReferralEntity(event.model);
        }
    }

    onDoctorsSelected(event) {
        if (event.isUserInput) {
            this.selectedProviders = event.value as DoctorDataModel[];
        }
    }

    selectReferralEntity(model: ReferralEntityModel) {
        // get Organization Primary Information
        this.organizationsService.getOrganization(model.OrganizationID).subscribe((orgs) => {
            if (orgs) {
                this.setReferralEntityOrganizationInfo(orgs);

            } else { // there is no Organization info
                this.selectedReferralEntity.Organization = new OrganizationReferralEntityModel();
            }
        }, err => {
            // this.createMessage('Error loading organizations', 'Error');
        });

        this.selectedProviders = [];
        this.selectedReferralEntity = model;
        if (this.selectedReferralEntity.cfgReferralEntityProviderDoctors.length > 0) {
            for (const doc of this.selectedReferralEntity.cfgReferralEntityProviderDoctors) {
                this.selectedProviders.push(this.staticDataService.currentLocationDoctors.find(x => x.DoctorId === doc.DoctorID));
            }
        }
    }


    loadTable() {
        this.referralService.getReferralEntityByTDOCID(this.selectedClient.TDOCID).subscribe((data) => {
            if (data) {
                this.listReferralEntities = data;
                if (this.ReferralEntityTable !== undefined) {
                    this.ReferralEntityTable.updateData(this.listReferralEntities);
                }
                if (this.listReferralEntities.length > 0) {
                    this.selectedReferralEntity = this.listReferralEntities[0];

                    // set Provider Doctor
                    if (this.selectedReferralEntity.cfgReferralEntityProviderDoctors.length > 0) {
                        for (const doc of this.selectedReferralEntity.cfgReferralEntityProviderDoctors) {
                            this.selectedProviders.push(this.staticDataService.currentLocationDoctors.find(x => x.DoctorId === doc.DoctorID));
                        }
                    }

                    if (this.selectedReferralEntity.OrganizationID !== null && this.selectedReferralEntity.OrganizationID !== undefined) {
                        this.organizationsService.getOrganization(this.selectedReferralEntity.OrganizationID).subscribe((orgs) => {
                            if (orgs) {
                                this.setReferralEntityOrganizationInfo(orgs);
                            } else { // there is no Organization info
                                this.selectedReferralEntity.Organization = new OrganizationReferralEntityModel();
                            }
                        });
                    }

                    const ivl = setInterval(() => {
                        if (this.ReferralEntityTable) {
                            clearInterval(ivl);
                            this.ReferralEntityTable.setSelectedModel(this.selectedReferralEntity);
                        }
                    }, 100);
                } else {
                    this.selectedReferralEntity = null;
                    this.selectedProviders = [];
                }

            }
        });
    }

    setReferralEntityOrganizationInfo(dataOrganization: OrganizationDataModel) {
        this.selectedReferralEntity.Organization = new OrganizationReferralEntityModel();
        this.selectedReferralEntity.Organization.Name = dataOrganization.OrganizationName;
        if (dataOrganization.dataOrganizationContacts.length > 0 && dataOrganization.dataOrganizationContacts[0].dataContact) {
            this.selectedReferralEntity.Organization.ContactFullName =  (dataOrganization.dataOrganizationContacts[0].dataContact.FirstName !== null ? dataOrganization.dataOrganizationContacts[0].dataContact.FirstName : '') + ' ' +
                                                                        (dataOrganization.dataOrganizationContacts[0].dataContact.MidName !== null ? dataOrganization.dataOrganizationContacts[0].dataContact.MidName : '') + ' ' +
                                                                        (dataOrganization.dataOrganizationContacts[0].dataContact.LastName !== null ? dataOrganization.dataOrganizationContacts[0].dataContact.LastName : '');
        }
        if (dataOrganization.dataOrganizationAddresses.length > 0 && dataOrganization.dataOrganizationAddresses[0].dataAddress) {
            const Address1 = dataOrganization.dataOrganizationAddresses[0].dataAddress.Address1 !== null ? dataOrganization.dataOrganizationAddresses[0].dataAddress.Address1 : '';
            const Address2 = dataOrganization.dataOrganizationAddresses[0].dataAddress.Address2 !== null ? dataOrganization.dataOrganizationAddresses[0].dataAddress.Address2 : '';
            const Address3 = dataOrganization.dataOrganizationAddresses[0].dataAddress.Address3 !== null ? dataOrganization.dataOrganizationAddresses[0].dataAddress.Address3 : '';
            const city = dataOrganization.dataOrganizationAddresses[0].dataAddress.City !== null ? dataOrganization.dataOrganizationAddresses[0].dataAddress.City : '';
            const state = dataOrganization.dataOrganizationAddresses[0].dataAddress.State !== null ? dataOrganization.dataOrganizationAddresses[0].dataAddress.State : '';
            const postalCode = dataOrganization.dataOrganizationAddresses[0].dataAddress.PostCode !== null ? dataOrganization.dataOrganizationAddresses[0].dataAddress.PostCode : '';

            this.selectedReferralEntity.Organization.AddressUpper = Address1 + ' ' + Address2 + ' ' + Address3;
            this.selectedReferralEntity.Organization.AddressBottom = city + ', ' + state + ', ' + postalCode;
        }
        this.organizationsService.getAllOrganizationContacts(this.selectedReferralEntity.OrganizationID).subscribe((contacts) => {
            if (contacts.length > 0) {
                if (contacts.find(x => x.dataContact !== null && x.dataContact.enumContactCategoryID === EnumContactCategory.Main_Contact)) {
                    if (contacts.find(x => x.dataContact.enumContactCategoryID === EnumContactCategory.Main_Contact).dataContact.dataContactComms.length > 0) {
                        this.selectedReferralEntity.Organization.ContactPhone = contacts.find(x => x.dataContact.enumContactCategoryID === EnumContactCategory.Main_Contact).dataContact.dataContactComms.find(x => x.enumCommMethodID === CommMethodEnum.Phone).Address;
                        this.selectedReferralEntity.Organization.ContactEmail = contacts.find(x => x.dataContact.enumContactCategoryID === EnumContactCategory.Main_Contact).dataContact.dataContactComms.find(x => x.enumCommMethodID === CommMethodEnum.Email).Address;
                    }
                }
            }
        }, err => {
            // this.createMessage('Error loading organization contacts', 'Error');
        });
    }

    changeClient(client: TdoClientConfigurationModel) {
        this.selectedClient = client;
        this.loadTable();
    }

    generateToken() {
        if (this.selectedReferralEntity.OrganizationID === undefined || this.selectedReferralEntity.OrganizationID === '') {
            this.dialogService.openConfirmDialog('Please, Saved  Referral Entity Data',
                false, false, 'Referral Client').subscribe((result) => {
                if (result === true) {
                }
            });
            return;
        }
        const enterpriseId = localStorage.getItem('TDOEnterpriseId');
        this.referralService.generateToken(this.selectedReferralEntity, enterpriseId).subscribe(token => {
            if (token) {
                // returned  token, copy into the corresponding label.
                this.selectedReferralEntity.URL = [this.currentURL, token].join('');
                this.onSave(originSaving.token);
            } else {
                this.dialogService.openConfirmDialog('There was an error when trying to create Token',
                    false, false, 'Referral Client').subscribe((result) => {
                    if (result === true) {
                    }
                });
            }
        });
    }

    sendEmail() {
        if (this.selectedReferralEntity.Organization.ContactEmail === undefined ||
            this.selectedReferralEntity.Organization.ContactEmail === '' ||
            this.selectedReferralEntity.Organization.ContactEmail ===  null) {
            this.dialogService.openConfirmDialog('Please, Create Main Contact Email',
                false, false, 'Referral Client').subscribe((result) => {
                if (result === true) {
                }
            });
            return;
        }
        this.emailInformation = new emailInformationModel();
        this.emailInformation.emailAddress = this.selectedReferralEntity.Organization.ContactEmail;
        this.emailInformation.referralContactName = this.selectedReferralEntity.ReferralClientName;
        this.emailInformation.url = this.selectedReferralEntity.URL;
        this.emailInformation.practiceName = this.selectedClient.Name;

        this.referralService.sendReferralEntityEmail(this.emailInformation).subscribe(result => {
            if (result) {
                this.dialogService.openConfirmDialog('Email sent successfully',
                    false, false, 'Referral Client').subscribe((result) => {
                    if (result === true) {
                    }
                });
            } else {
                this.dialogService.openConfirmDialog('There was an error when trying to send email',
                    false, false, 'Referral Client').subscribe((result) => {
                    if (result === true) {
                    }
                });
            }
        });
    }

    onNew(event) {
        this.configurationService.setDirty();
        const model = new ReferralEntityModel();
        model.ReferralClientName = '';
        model.TDOCID = this.selectedClient.TDOCID;
        model.Organization = new OrganizationReferralEntityModel();
        this.selectedReferralEntity = model;
        this.selectedProviders = [];
    }

    onSave(typeOfSaving: originSaving){
    // validate fields
        if (this.selectedReferralEntity.ReferralClientName === undefined || 
            this.selectedReferralEntity.ReferralClientName ==='' ||
            this.selectedProviders.length === 0) {

            let message ='<b>Please enter following:</b><br/>';

            if (this.selectedReferralEntity.ReferralClientName === undefined || 
                this.selectedReferralEntity.ReferralClientName ==='' )
                {
                message +='<br/>Referral Client Name';
                }

            if (this.selectedProviders.length === 0 )
                {
                message +='<br/>Select Provider doctor';
                }
    

            this.dialogService.openConfirmDialog(message, 
                false, false, 'Referral Client').subscribe((result) => {
                if (result === true) {
                }
            });
            return;
        }

        this.selectedReferralEntity.cfgReferralEntityProviderDoctors = [];
        for (const doctor of this.selectedProviders) {
            if (this.selectedReferralEntity.ReferralEntityID === undefined) {
                const newProvider: ReferralEntityProviderDoctorsModel = new ReferralEntityProviderDoctorsModel();
                newProvider.DoctorID = doctor.DoctorId;
                newProvider.ReferralEntityDocID = '';
                newProvider.ReferralEntityID = '';

                this.selectedReferralEntity.cfgReferralEntityProviderDoctors.push(newProvider);

            } else {
                const existingItem = this.selectedReferralEntity.cfgReferralEntityProviderDoctors.findIndex(x => x.DoctorID === doctor.DoctorId);
                // If the item exists, update it; otherwise, push it to the destination array
                if (existingItem !== -1) {
                } else {
                    const newProvider: ReferralEntityProviderDoctorsModel = new ReferralEntityProviderDoctorsModel();
                    newProvider.DoctorID = doctor.DoctorId;
                    this.selectedReferralEntity.cfgReferralEntityProviderDoctors.push(newProvider);
                }
            }
        }
        this.referralService.saveReferralEntity(this.selectedReferralEntity).subscribe(data => {
            if (data) {
                const existingItem = this.listReferralEntities.findIndex(x => x.ReferralEntityID === data.ReferralEntityID);
                if (existingItem !== -1) {
                } else { // New Referral Entity
                    this.listReferralEntities.push(data);
                    if (this.ReferralEntityTable !== undefined) {
                        this.ReferralEntityTable.updateData(this.listReferralEntities);
                        this.selectedReferralEntity = this.listReferralEntities.find(x => x.ReferralEntityID === data.ReferralEntityID);

                        const ivl = setInterval(() => {
                            if (this.ReferralEntityTable) {
                                clearInterval(ivl);
                                this.ReferralEntityTable.setSelectedModel(this.selectedReferralEntity);
                            }
                        }, 100);
                    }
                }

                if (typeOfSaving === originSaving.organization){ // if saved action is from Organization button
                    this.openOrganizationDialog(false, this.selectedReferralEntity.OrganizationID);
                }
                else if ( typeOfSaving === originSaving.form)
                {
                    this.dialogService.openConfirmDialog('Referral Information Saved!',
                        false, false, 'Referral Client').subscribe((result) => {
                        if (result === true) {
                        }
                    });
                }
                else if (typeOfSaving === originSaving.token){
                    this.dialogService.openConfirmDialog('Token was successfully created',
                        false, false, 'Referral Client').subscribe((result) => {
                        if (result === true) {
                        }
                    });
                }
            }

        });
    }

    onNameInput(event: Event) {
        if (!this.editedReferralsEntity.includes(this.selectedReferralEntity)) {
            this.editedReferralsEntity.push(this.selectedReferralEntity);
        }
    }

    CheckIfSendEmailDisabled() {
        return (!this.selectedReferralEntity.ReferralEntityID || this.selectedReferralEntity.ReferralEntityID.length === 0) ||
      (!this.selectedReferralEntity.Organization) ||
      (!this.selectedReferralEntity.URL || this.selectedReferralEntity.URL.length === 0);
    }

    openOrganization(viewOnly: boolean, organizationID: string) {
        if ((this.selectedReferralEntity.ReferralClientName === '' || this.selectedProviders.length === 0) && (this.selectedReferralEntity.ReferralEntityID === Constants.emptyGuid || this.selectedReferralEntity.ReferralEntityID === undefined)) {
            this.dialogService.openConfirmDialog('Please enter Referral Client Name and  select Provider doctor!',
                false, false, 'Referral Client').subscribe((result) => {
                if (result === true) {
                }
            });
            return;
        }

        if (organizationID === undefined || organizationID === null) { // Save Referral Entity and create Organization
            this.onSave(originSaving.organization);
        } else { // just open Dialog
            this.openOrganizationDialog(viewOnly, organizationID);
        }
    }

    openOrganizationDialog(viewOnly: boolean, organizationID: string){
        const dialogRef = this.dialog.open(OrganizationConfigurationDialogComponent, {
            width: '700px',
            height: '900px',
            panelClass: 'dialog',
            data: {
                isDialogMode: true,
                isViewOnly: viewOnly,
                enumOrganizationTypeId: Constants.emptyGuid,
                organizationId: organizationID,
                showOrganizationTypeSelection: false
            }
        }).afterClosed().subscribe((data) => {
            this.selectReferralEntity(this.selectedReferralEntity);
        });
    }
}
